import { useTranslation } from "react-i18next";
import { useAdminData } from "../../context/AdminDataContext";
import RealTimeFlatReadings from "./RealTimeFlatReadings";

const AdminRealtimePage = () => {
  const { t } = useTranslation();
  const { realTimeData, loading, error } = useAdminData();

  if (loading) {
    return <p className="text-gray-600">{t("admin_loading_data")}</p>;
  }
  if (error) {
    return (
      <p className="text-red-600">
        {t("admin_error")}: {error}
      </p>
    );
  }

  return <RealTimeFlatReadings realTimeData={realTimeData} />;
};

export default AdminRealtimePage;
